import React, { useState } from "react";
import validator from "validator";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import financeMessage from "../../../../messages/finance";
import { useEffect } from "react";
import Pagination from "../../../partials/content/Pagination";

export default function AllScoreLogPosition() {
  const [message, setMessage] = useState();
  const [allScoreLogPosition, setAllScoreLogPosition] = useState([]);
  const [positionTagHtmlID, setPositionTagHtmlID] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [campaignID, setCampaignID] = useState(0);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    if (!positionTagHtmlID) {
      return;
    }
    getAllScoreLogPosition();
  }, [currentPage, campaignID, positionTagHtmlID]);

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (campaignID) {
      searchFilterQuery = `${searchFilterQuery}&campaign_id=${campaignID}`;
    }

    return searchFilterQuery;
  };

  const sendForm = async () => {
    const positionTagHtmlID = getPositionTagHtmlID();
    if (!positionTagHtmlID) {
      return;
    }
    setPositionTagHtmlID(positionTagHtmlID);
  };

  const getPositionTagHtmlID = () => {
    const positionTagHtmlID = document.querySelector(
      "#position-tag-html-id"
    ).value;

    if (!positionTagHtmlID) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    if (
      !positionTagHtmlID.includes(
        process.env.REACT_APP_HILITE_TAG_HTML_POSITION_ID
      )
    ) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    const positionID = positionTagHtmlID.replace(
      process.env.REACT_APP_HILITE_TAG_HTML_POSITION_ID,
      ""
    );

    if (!validator.isNumeric(positionID)) {
      setMessage({
        type_class: "alert alert-danger",
        text: financeMessage.POSITION_TAG_HTML_ID_INVALID,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return positionTagHtmlID;
  };

  const getAllScoreLogPosition = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allScoreLogPosition = await sendRequestGetAllWalletLogPosition(
      positionTagHtmlID,
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allScoreLogPosition) {
      return;
    }

    setAllScoreLogPosition(allScoreLogPosition.position_log_score);
    setCountPage(allScoreLogPosition.count_page);
  };

  const sendRequestGetAllWalletLogPosition = async (
    positionTagHtmlID,
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderRequest();
    let allScoreLogPosition;
    try {
      allScoreLogPosition = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/position-score-log/position/${positionTagHtmlID}/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allScoreLogPosition.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAllScoreLogPosition = () => {
    return (
      <>
        <div className="alert alert-info mt-2">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره کمپین </label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setCampaignID(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="pb-4 px-2">
          <div className="table-responsive pt-2">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره گزارش مالی جایگاه</td>
                  <td>Hicoin</td>
                  <td>شماره کمپین جایگزین</td>
                  <td>تاربخ درج</td>
                </tr>
              </thead>
              <tbody>
                {allScoreLogPosition.map((item, index) => {
                  return (
                    <tr>
                      <td>{helperNumbers.toPersianNum(index + 1)}</td>
                      <td>{helperNumbers.toPersianNum(item.ppsl_id)}</td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(item.ppsl_score)
                        )}
                      </td>
                      <td>{item.ppsl_campaign_alternative_id}</td>
                      <td>
                        {helperNumbers.toPersianNum(
                          item.ppsl_created_at.split(" ")[1] +
                            " " +
                            helperTime.convertGregorianToJalali(
                              item.ppsl_created_at.split(" ")[0]
                            )
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
      </>
    );
  };

  const generatePositionDoseNotHaveScoreLog = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img src="/assets/img/do-not-have-position.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p> این جایگاه در حال حاضر هیچ گزارشی ندارد </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-finance"
        activeItem="manage-all-score-log-position"
      />

      <div className="content-wrapper">
        <TitleBar title="گزارش Hicoin جایگاه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <div className="w-50">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    sendForm();
                  }}
                >
                  <div class="input-group ">
                    <input
                      type="text"
                      id="position-tag-html-id"
                      class="form-control"
                      placeholder="تگ html جایگاه را وارد کنید"
                      required
                    />
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="submit">
                        نمایش
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {allScoreLogPosition.length === 0 && !positionTagHtmlID ? (
              <></>
            ) : (
              generateAllScoreLogPosition()
            )}
          </div>
        </section>
      </div>
    </>
  );
}
